import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { productBrand } from "../productBrand";

const LOGO_TEXT = productBrand.name;
const LANDING_NAVBAR_FONT = productBrand.wordmarkFontFamily;
const CHAR_INTERVAL_MS = 55;
const HOLD_MS = 450;

const PodscopeTypingLoader: React.FC = () => {
  const [charCount, setCharCount] = useState(0);

  useEffect(() => {
    const delay =
      charCount < LOGO_TEXT.length ? CHAR_INTERVAL_MS : HOLD_MS;
    const id = window.setTimeout(() => {
      setCharCount((current) =>
        current < LOGO_TEXT.length ? current + 1 : 0,
      );
    }, delay);
    return () => window.clearTimeout(id);
  }, [charCount]);

  return (
    <Box
      role="status"
      aria-label={`Cargando ${productBrand.name}`}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        minHeight: "inherit",
      }}
    >
      <Box
        component="span"
        sx={{
          display: "inline-flex",
          alignItems: "baseline",
          fontFamily: LANDING_NAVBAR_FONT,
          fontWeight: 800,
          fontSize: { xs: "2rem", md: "2.5rem" },
          color: "text.primary",
          letterSpacing: "-0.02em",
        }}
      >
        <Typography
          component="span"
          sx={{
            font: "inherit",
            color: "inherit",
            letterSpacing: "inherit",
          }}
        >
          {LOGO_TEXT.slice(0, charCount)}
        </Typography>
        <Box
          component="span"
          aria-hidden
          sx={{
            display: "inline-block",
            width: "2px",
            height: "0.9em",
            ml: "1px",
            bgcolor: "text.primary",
            animation: "podscopeCursorBlink 0.7s step-end infinite",
            "@keyframes podscopeCursorBlink": {
              "0%, 100%": { opacity: 1 },
              "50%": { opacity: 0 },
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default PodscopeTypingLoader;
